module.exports = ".btn {\n  border: 1px solid #e5e5e5;\n  height: 35px;\n  width: 35px;\n  min-width: 35px;\n  min-height: 35px; }\n\n.btn-without-label {\n  padding-left: .25rem !important;\n  padding-right: .25rem !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/social-share/social-share.component.scss
// module id = ./src/app/shared/social-share/social-share.component.scss
// module chunks = main